import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import SplitOne from "../elements/split/SplitOne";
import ServiceOne from "../elements/service/ServiceOne";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import PricingFive from "../elements/pricing/PricingFive";
import SlipThree from "../elements/split/SlipThree";
import ServiceFour from "../elements/service/ServiceFour";
import SplitFive from "../elements/split/SplitFive";
import ServiceSix from "../elements/service/ServiceSix";


const ecommerce = () => {
    return (
        <>
            <SEO title="CSMS Development"/>
            <Layout>
                {/* Start Slider Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">E-Commerce Design & Development</h3>
                                    <p className="mb--10">Mixon Softwares offers ecommerce website design and development services
                                        that cater specifically to the needs of your business. Our team of
                                        experienced ecommerce developers work to create a unique ecommerce solution
                                        that encompasses a visually appealing design, advanced functionality, and user-friendly
                                        customer experience. Our services include the creation of custom storefronts, the development
                                        of scalable micro services architecture, and the digital transformation of your back-office
                                        ecommerce operations.
                                    </p>
                                    <p>
                                        We can assist you with a variety
                                        of web marketing methods based on our extensive knowledge. Our team of accommodating
                                        web designers will work with you to guarantee your final product is exactly what you
                                        envisioned.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/ios/ecommerce2.png" alt="cms Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="Why Choose Us for E-commerce Development"
                                    description="Mixon Softwares specializes in creating technology solutions for ecommerce businesses to enhance customer experience and streamline back-office operations."/>
                            </div>
                        </div>
                        <ServiceSix
                            serviceStyle="service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default ecommerce;
